<template>
  <div class="order-kanban-header">
    <div class="d-flex">
      <div class="order-kanban-header__info">
        <h6 v-if="data.kanban_meta.parent_column">
          {{ data.kanban_meta.reference_status_name }}
        </h6>
        <div
          v-if="!data.kanban_meta.parent_column && data.kanban_meta.user_name"
          class="font-weight-bold"
        >
          {{ data.kanban_meta.user_name }}
        </div>

        <span
          class="d-inline-flex align-items-center"
          :id="`total-services-${data.kanban_meta.reference_status_id}-${data.kanban_meta.user_id}`"
        >
          <span>
            {{
              numberDeclension(data.meta.total || 0, [
                "сделка",
                "сделки",
                "сделок",
              ])
            }}
          </span>
          <b-icon-info-circle
            v-if="hasTotalServices"
            class="ml-1"
            variant="primary"
          />
          <b-spinner
            v-if="data.loading_status"
            class="ml-1"
            variant="primary"
            small
            label="Spinning"
          ></b-spinner>

          <b-tooltip
            :target="`total-services-${data.kanban_meta.reference_status_id}-${data.kanban_meta.user_id}`"
            triggers="hover"
            placement="top"
          >
            <div
              v-for="service in data.meta.total_services"
              :key="service.reference_service_id"
            >
              {{ `${service.reference_service_name}: ${service.total}` }}
            </div>
          </b-tooltip>
        </span>
      </div>
      <div class="order-kanban-header__action">
        <b-icon-arrow-clockwise
          font-scale="1.5"
          style="animation-duration: 0.5s"
          variant="primary"
          class="cursor-pointer mb-1"
          :animation="data.loading_status ? 'spin' : ''"
          @click="$emit('refresh')"
        />
        <b-icon-people-fill
          v-if="data.nested_columns.length > 0"
          font-scale="1.5"
          :variant="data.kanban_meta.all_users_opened ? 'primary' : 'secondary'"
          class="cursor-pointer"
          @click="$emit('open-nested')"
        />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    hasTotalServices() {
      return !!this.data.meta.total_services && this.data.meta.total_services.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped src="~/components/orderKanban/OrderKanbanHeader.scss" />
